import { render, staticRenderFns } from "./NoteThread.vue?vue&type=template&id=2729e83c&"
import script from "./NoteThread.vue?vue&type=script&lang=ts&"
export * from "./NoteThread.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports